export default __webpack_public_path__ + "static/media/UserGuide_de_DE.82439b92.pdf";